import { useMutation } from "@tanstack/react-query";
import useRetryFetch from "./useRetryFetch";
import { searchProducts, RagProductSearchRequest, RagProductSearchResponse } from "../api/rag";

/**
 * Hook for RAG semantic product search.
 * Uses useMutation (not useQuery) since it's a POST-based search triggered on demand.
 */
export function useRagProductSearch() {
  const retryFetch = useRetryFetch();

  return useMutation<RagProductSearchResponse, Error, RagProductSearchRequest>({
    mutationFn: (data: RagProductSearchRequest) => searchProducts(retryFetch, data),
  });
}
